import Joi from 'joi'

import errorsResolver from '../../../../validation/schemeUtils'

const FIELD_LENGTH = 100
const DEAL_NUMBER_MAX = 14
const DEAL_NUMBER_MIN = 3

export const dealNumberShema = Joi.object({
  dealNumber: Joi.string()
    .max(DEAL_NUMBER_MAX)
    .min(DEAL_NUMBER_MIN)
    .required('')
    .pattern(new RegExp(`^[a-zA-Z0-9\\-]{1,12}-[0-9]{1,12}(-[0-9]{1,12})?$`))
    .error(errorsResolver({
      max: `Номер договора должен быть до ${DEAL_NUMBER_MAX} символов`,
      required: `Номер договора обязательное поле`,
      pattern: `Номер договора содержит некорректные символы`,
      min: `Номер договора должен быть не менее ${DEAL_NUMBER_MIN} символов`
    }))
})

export const basePercentShema = Joi.object({
  basePercent: Joi.number()
    .error(errorsResolver({
      number: `Должно быть число`
    }))
})

export const delayPercentShema = Joi.object({
  delayPercent: Joi.number()
    .error(errorsResolver({
      number: `Должно быть число`
    }))
})

export const cashBoxShema = Joi.object({
  cashBoxId:
    Joi.object({
      label: Joi.string()
        .max(FIELD_LENGTH)
        .required('')
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9№\\- ]*$'))
        .error(errorsResolver({
          max: `Подразделение должно быть до ${FIELD_LENGTH} символов`,
          required: `Подразделение обязательное поле`,
          pattern: `Подразделение содержит некорректные символы`
        })),
      value: Joi.number()
        .error(errorsResolver({
          number: `Должно быть число`
        }))
    })
      .invalid(null)
      .required()
      .min(1)
      .error(errorsResolver({
        invalid: `Подразделение обязательное поле`,
        required: `Подразделение обязательное поле`,
        min: `Подразделение обязательное поле`
      }))
})

export const redemptionDateSchema = Joi.object({
  redemptionDate: Joi.date()
    .iso()
    .error(errorsResolver({
      dateFormat: `Некорректная дата`
    }))
})
